export default Object.freeze({
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE',
});
